import { useTranslation } from 'react-i18next';
import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useInstrument} from "../../features/instrument/instrument.ctx";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import {filter, find, get, includes, isEmpty} from 'lodash';
import Autocomplete from "@mui/material/Autocomplete";
import {DocumentRowWrapper} from "./document-list";

const References = ({name, ...restProps}) => {
  const {t} = useTranslation();
  const [currData, setCurrData] = useState([]);
  const {instrumentKeys} = useInstrument();
  const [dateVal, setDateVal] = useState(null);

  useEffect(() => {
    setDateVal(get(currData, 'replacedBy[0].date'));
  }, [currData]);

  return (
      <Controller
          name={name}
          render={({field}) => {

            if (field?.value)
              setCurrData(field.value)
            return (
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={3}>
                        {t("RELATION TYPE")}
                      </Grid>
                      <Grid item xs={7}>
                        {t("LEGAL INSTRUMENT")}
                      </Grid>
                      <Grid item xs={2}>
                        {t("DATE")}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <DocumentRowWrapper>
                      <Grid container>
                        <Grid item xs={3}>
                          {t("Replaced by")}
                        </Grid>
                        <Grid item xs={7} pr={3}>
                          <Autocomplete
                              fullWidth
                              size="small"
                              multiple={true}
                              renderInput={params => (
                                  <TextField
                                      {...params}
                                      InputProps={{ ...params.InputProps,style: {fontSize: 12}}}
                                      placeholder={isEmpty(field?.value?.replacedBy) ? t('click here to select') : undefined}
                                  />
                              )}
                              options={instrumentKeys}
                              getOptionLabel={option => `${get(option, 'key')} ${get(option, 'title')}`}
                              disableCloseOnSelect={false}
                              onChange={(e, nVal) => {
                                let tmp = nVal.map(e => ({id: e.id, key: e.key, date: dateVal}));
                                field.onChange({...field.value, replacedBy: tmp});
                              }}
                              value={filter(instrumentKeys, cv => currData.replacedBy?.some(e => e.id === cv.id))}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <DesktopDatePicker
                              componentsProps={{
                                actionBar: {
                                  actions: ['clear'],
                                },
                              }}
                              size="small"
                              inputProps={{style: {fontSize: 12, width: 100}}}
                              value={dateVal}
                              onChange={(e) => {
                                let tmp = currData.replacedBy;

                                if(e) {
                                  tmp = tmp.map(d => ({...d, date: e.format('YYYY-MM-DD')}));
                                } else {
                                  tmp = tmp.map(d => ({...d, date:null}));
                                }
                                field.onChange({...field.value, replacedBy: tmp});
                              }}
                              renderInput={(params) => <TextField size="small" {...params} />}
                          />
                        </Grid>
                      </Grid>
                    </DocumentRowWrapper>
                  </Grid>
                  
                  <Grid item xs={12} mt={1}>
                    <DocumentRowWrapper>
                      <Grid container>
                        <Grid item xs={3}>
                          {t("Replaces")}
                        </Grid>
                        <Grid item xs={7} pr={3}>
                          {
                            field?.value?.replaces?.map((replace) => {
                              instrumentKeys.find(
                                instrument => instrument.key === replace.key
                              );

                              return (
                                <span
                                  style={{ color: 'blue', fontSize: '10px' }}>
                                    <a href={`/en/instruments/${replace.key.replace(/\//g, '-')}`}>{replace.key}</a> 
                                </span>
                              );
                            })
                          }
                        </Grid>
                      </Grid>
                    </DocumentRowWrapper>
                  </Grid>


                  <Grid item xs={12} mt={1}>
                    <DocumentRowWrapper>
                      <Grid container>
                        <Grid item xs={3}>
                          {t("Is related to")}
                        </Grid>
                        <Grid item xs={7} pr={3}>
                          <Autocomplete
                              fullWidth
                              size="small"
                              multiple={true}
                              renderInput={params => (
                                  <TextField
                                      {...params}
                                      InputProps={{ ...params.InputProps,style: {fontSize: 12}}}
                                      placeholder={isEmpty(field?.value?.relatedTo) ? t('click here to select') : undefined}
                                  />
                              )}
                              options={instrumentKeys}
                              getOptionLabel={option => `${get(option, 'key')} ${get(option, 'title')}`}
                              disableCloseOnSelect={false}
                              onChange={(e, nVal) => {
                                let tmp = nVal.map(e => ({id: e.id, key: e.key}));
                                field.onChange({...field.value, relatedTo: tmp});
                              }}
                              value={filter(instrumentKeys, cv => currData.relatedTo?.some(e => e.id === cv.id))}
                          />
                        </Grid>
                      </Grid>
                    </DocumentRowWrapper>
                  </Grid>
                </Grid>
            )
          }}
      />
  )
};

export default References;
